export const willingToTravelList = {
  Yes: 0,
  No: 1,
};

export const relocationList = {
  WithinState: 0,
  WithinCountry: 1,
  AnyWhere: 2,
};

export const noticePeriodInDaysList = {
  Immediately: 0,
  '30 Days': 1,
  '45 Days': 2,
  '60 Days': 3,
  '90 Days': 4,
};

export const authorizationCategoryList = {
  Citizen: 0,
  'Visa Independent': 1,
  'Visa Dependent': 2,
  Others: 3,
};

export const germanyVisaIndependentList = {
  'EU Citizens': 0,
  'Blue Card Holders': 1,
};

export const ukVisaIndependentList = { 'Tier 1': 0, ILR: 1, 'Tier 2 Dependent': 2 };

export const usVisaIndependentList = {
  GC: 0,
  'GC EAD': 1,
  'H4 EAD': 2,
  'L2 EAD': 3,
  TN: 4,
  E3: 5,
  'OPT EAD': 6,
  CPT: 7,
};

export const polandVisaIndependentList = { 'Karta Pobytu': 0 };

export const germanyVisaDependentList = { 'Work Permit': 0 };

export const ukVisaDependentList = { 'Tier 2 General': 0, 'Tier 4': 1 };

export const usVisaDependentList = { H1B: 0, L1: 1 };

export const communicationPreferenceList = {
  Email: 0,
  Phone: 1,
};

export const jobPreferenceList = {
  Permanent: 0,
  Contract: 1,
};

export const currentJobTypeList = {
  Permanent: 0,
  Contract: 1,
  Temporary: 2,
};
